import React from 'react'
import { Copy, Download, Printer } from 'lucide-react'
import { useTranslation as useInterfaceLanguage } from 'react-i18next'
import { tr } from 'i18n'
import { DateTime } from 'components/Erp/Display'
import s from './DriverBaseList.module.scss'

const mediaUrl = value => typeof value === 'string' ? value : value?.url
const displayValue = value => value === null || value === undefined || value === '' ? '—' : value

async function copyUid(uid) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(String(uid))
      return
    }
  } catch {
    // The fallback also supports browsers without clipboard permissions.
  }
  const textarea = document.createElement('textarea')
  textarea.value = String(uid)
  textarea.readOnly = true
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  try {
    textarea.select()
    document.execCommand('copy')
  } catch {
    // Clipboard failures should not interrupt the driver controls.
  } finally {
    textarea.remove()
  }
}

function DetailField({ label, children, className = '' }) {
  return <div className={`${s.detailField} ${className}`}>
    <dt>{tr(label)}</dt>
    <dd>{children}</dd>
  </div>
}

export default function BaseDriverDetails({ driver = {}, privatePoint = false, onPrint = () => {}, onDownload = () => {} }) {
  useInterfaceLanguage()
  const photo = mediaUrl(driver.photo)
  const qrImage = mediaUrl(driver.qrcode_img)
  const download = event => {
    event.stopPropagation()
    onDownload(driver)
  }

  return <div className={s.details}>
    <dl className={s.detailGrid}>
      <DetailField label="UID">
        {driver.uid ? <button type="button" className={s.uid} onClick={event => {
          event.stopPropagation()
          copyUid(driver.uid)
        }}><Copy size={14} aria-hidden="true" />{driver.uid}</button> : '—'}
      </DetailField>
      <DetailField label="QR строка"><span className={s.code}>{displayValue(driver.qrcode_scr)}</span></DetailField>
      <DetailField label="Дополнительный ном.тел."><span className={s.phone}>{displayValue(driver.phone)}</span></DetailField>
      <DetailField label="Создано"><DateTime value={driver.created_at} /></DetailField>
      {privatePoint && <>
        <DetailField label="Срок пропуска (дней)">{displayValue(driver.pass_expiry_days)}</DetailField>
        <DetailField label="Пропуск действует до"><DateTime value={driver.pass_expiry_date} dateOnly /></DetailField>
        <DetailField label="Лимит погрузок">{displayValue(driver.pass_loads_limit)}</DetailField>
        <DetailField label="Погрузок по пропуску">{driver.pass_loads_count ?? 0}</DetailField>
      </>}
      <DetailField label="Фото" className={s.mediaField}>
        {photo ? <img className={s.thumbnail} src={photo} alt={tr('Автомобиль ') + (driver.vehicle_number || driver.id)} /> : '—'}
      </DetailField>
      <DetailField label="QR (изображение)" className={s.mediaField}>
        {qrImage ? <button type="button" className={s.qrButton} aria-label={tr('QR (изображение)')} title={tr('Скачать')} onClick={download}>
          <img className={s.thumbnail} src={qrImage} alt={`qrcode-${driver.id}`} />
        </button> : '—'}
      </DetailField>
    </dl>
    <div className={s.detailActions}>
      <button type="button" className={s.button} onClick={event => {
        event.stopPropagation()
        onPrint(driver)
      }}><Printer size={14} aria-hidden="true" />{tr(' Печать')}</button>
      <button type="button" className={s.button} onClick={download}><Download size={14} aria-hidden="true" />{tr('Скачать')}</button>
    </div>
  </div>
}
